import { Image as ImageIcon, ChevronRight } from 'lucide-react';
import type { ExpenseReceipt } from '../../types/expense';
import { StatusChip } from './StatusChip';
import { formatMoney, formatDate } from './format';

interface Props {
    receipt: ExpenseReceipt;
    /** Show the owner email (manager view). */
    showOwner?: boolean;
    onClick?: () => void;
}

export function ExpenseCard({ receipt, showOwner, onClick }: Props) {
    const title = receipt.Vendor || receipt.CategoryLabel || 'Untitled receipt';
    return (
        <button
            type="button"
            onClick={onClick}
            className="w-full text-left rounded-2xl border border-gray-200 bg-white p-3 hover:border-gray-300 active:scale-[0.995] transition"
        >
            <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-gray-100 text-gray-400">
                    <ImageIcon className="h-5 w-5" />
                </div>
                <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                        <p className="truncate font-medium text-gray-900">{title}</p>
                        <span className="ml-auto flex-shrink-0 font-semibold text-gray-900">
                            {formatMoney(receipt.GrossAmount, receipt.Currency)}
                        </span>
                    </div>
                    <div className="mt-0.5 flex items-center gap-2 text-xs text-gray-500">
                        <span>{formatDate(receipt.ExpenseDate)}</span>
                        {receipt.CategoryLabel && <span className="truncate">· {receipt.CategoryLabel}</span>}
                        <span className="uppercase">· {receipt.CompanyCode}</span>
                    </div>
                    <div className="mt-1.5 flex items-center gap-2">
                        <StatusChip status={receipt.Status} />
                        {showOwner && (
                            <span className="truncate text-xs text-gray-400">{receipt.UserEmail}</span>
                        )}
                    </div>
                </div>
                <ChevronRight className="h-4 w-4 flex-shrink-0 text-gray-300" />
            </div>
        </button>
    );
}
